import { Col, Row } from 'react-bootstrap';
import AccreditationCard from '../AccreditationCard/AccreditationCard';
import React from 'react';
import { IAccreditation } from '../../../interfaces/IAccreditation';
import { ApplicationAction } from './ApplicationsBlock';
import { IAccreditationApplication } from '../../../interfaces/IAccreditationApplication';

interface Props {
    accreditations: IAccreditation[]; // The represented accreditation
    applications: IAccreditationApplication[];
    header: string;
    onSelectApplication: (app: IAccreditationApplication, action: ApplicationAction) => void;
    onSubmitFinalApplication: (app: IAccreditationApplication) => void;
    onSubmitForReview: (app: IAccreditationApplication) => void;
}

const ONE_DAY = 1000 * 60 * 60 * 24;

const AccreditationsBlockList: React.FC<Props> = ({
    accreditations,
    applications,
    header,
    onSelectApplication,
    onSubmitFinalApplication,
    onSubmitForReview,
}) => {
    const isExpiringWithinDays = (accreditation: IAccreditation, days: number) => {
        return (
            !accreditation?.endDate ||
            new Date(accreditation.endDate).getTime() - new Date().getTime() < days * ONE_DAY
        );
    };

    return (
        <>
            <h2 className={'fs-2 mb-4'}>{header}</h2>
            {accreditations.map((accreditation, index) => {
                const application = applications.find(
                    (application) =>
                        application.isRenewal &&
                        application.accreditationType?.accreditationTypeId ===
                            accreditation.accreditationType.accreditationTypeId
                );

                const isDateWithinRenewableWindow = isExpiringWithinDays(accreditation, 100);
                const isDateWithinUrgentWindow = isExpiringWithinDays(accreditation, 28);

                return (
                    <Row
                        key={`accreditation-${index}`}
                        className={index === accreditations.length - 1 ? 'mb-4' : ''}
                    >
                        <Col>
                            <AccreditationCard
                                accreditation={accreditation}
                                application={application}
                                onViewApplication={() =>
                                    application && onSelectApplication(application, 'view')
                                }
                                onRenewAccreditation={() => {
                                    if (isDateWithinRenewableWindow && application) {
                                        onSelectApplication(application, 'renew');
                                    }
                                }}
                                onSubmitFinalApplication={() =>
                                    onSubmitFinalApplication(application!)
                                }
                                onSubmitForReview={() => onSubmitForReview(application!)}
                                urgent={isDateWithinUrgentWindow}
                                renewable={isDateWithinRenewableWindow}
                            />
                        </Col>
                    </Row>
                );
            })}
        </>
    );
};

export default AccreditationsBlockList;
